module.exports = __webpack_public_path__ + "img/logo.806b916f.svg";